
var stateManager = require('../state/stateManager.js');


var alertAction = require('../state/actions/views/alertDialogue/alertAction.js');
var AlertPayload = require('../state/actions/views/alertDialogue/alertPayload.js');

var promptAction = require('../state/actions/views/prompt/promptAction.js');
var PromptPayload = require('../state/actions/views/prompt/promptPayload.js');
var LoginDialoguePayload = require('../../utils/state/actions/views/loginDialogue/loginDialoguePayload');
var loginDialogueAction = require('../../utils/state/actions/views/loginDialogue/loginDialogueAction');
var screenSaverAction = require('../../utils/state/actions/views/screenSaver/screenSaverAction');

var stringUtil = require('../string/stringUtil.js');
var guidUtil = require('../guid/guidUtil.js');

module.exports.showCriticalAlert = function (errorMessage)
{
    this.showAlert("critical", errorMessage);
}

module.exports.showErrorAlert = function (errorMessage)
{
    this.showAlert("error", errorMessage);
}

module.exports.showSuccessAlert = function (successMessage)
{
    this.showAlert("success", successMessage);
}

module.exports.showWarningAlert = function (warningMessage)
{
    this.showAlert("warning", warningMessage);
}

module.exports.showInfoAlert = function (infoMessage)
{
    this.showAlert("info", infoMessage);
}

module.exports.showAlert = function (type, message, toastId)
{
    if (stringUtil.isStringNullOrEmpty(message) || stringUtil.isStringNullOrEmpty(type))
    {
        stateManager.getStore().dispatch(alertAction.createAction(null));
    }

    stateManager.getStore().dispatch(screenSaverAction.createAction(false));

    if(stringUtil.isStringNullOrEmpty(toastId))
        toastId = guidUtil.generateGuid();

    var alertPayload = new AlertPayload();
    alertPayload.type = type;
    alertPayload.message = message;
    alertPayload.toastId = toastId;

    stateManager.getStore().dispatch(alertAction.createAction(alertPayload));
}

module.exports.clearAlert = function ()
{
    this.showAlert(null, null);
}

module.exports.clearAlertForId = function (toastId)
{
    var alertPayload = new AlertPayload();
    alertPayload.type = "clear.notification";
    alertPayload.toastId = toastId;

    stateManager.getStore().dispatch(alertAction.createAction(alertPayload));
}

module.exports.showPrompt = function (title, message, confirmationMessage, onYes, onNo)
{
    var promptPayload = new PromptPayload();
    promptPayload.title = title
    promptPayload.message = message
    promptPayload.confirmationMessage = confirmationMessage;
    promptPayload.onYes = onYes
    promptPayload.onNo = onNo

    stateManager.getStore().dispatch(promptAction.createAction(promptPayload));
}

module.exports.closePrompt = function ()
{
    stateManager.getStore().dispatch(promptAction.createAction(null));
}


module.exports.showLoginDialogue = function (onLogin)
{
    let loginDialoguePayload  = new LoginDialoguePayload();
    loginDialoguePayload.onLogin = (staff)=>
    {
        onLogin(staff);
    }
    loginDialoguePayload.pinAllowed = true;
    stateManager.getStore().dispatch(loginDialogueAction.createAction(loginDialoguePayload));
}
